export default __webpack_public_path__ + "static/media/left.2a18ee09.jpg";